export default __webpack_public_path__ + "static/media/Internal audit.99e290f6.png";